import { transformBetweenListTypes, transformToTaskList, transformTaskListToBlockNodes, isBulletOrOrderedList, isTaskList, getFormattedNode } from '@atlaskit/editor-common/transforms';
export var toggleTaskList = function toggleTaskList() {
  var targetType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'paragraph';
  return function (_ref) {
    var tr = _ref.tr;
    var nodes = tr.doc.type.schema.nodes;
    var selection = tr.selection;
    var _getFormattedNode = getFormattedNode(tr),
      node = _getFormattedNode.node,
      pos = _getFormattedNode.pos;
    if (node !== null && pos !== null) {
      if (isBulletOrOrderedList(node.type)) {
        var context = {
          sourceNode: node,
          sourcePos: pos,
          targetNodeType: nodes.taskList,
          tr: tr
        };
        return transformBetweenListTypes(context);
      }
      if (isTaskList(node.type)) {
        var _context = {
          sourceNode: node,
          sourcePos: pos,
          targetNodeType: nodes[targetType],
          tr: tr
        };
        return targetType === 'paragraph' ? transformTaskListToBlockNodes(_context) : transformBetweenListTypes(_context);
      }
      var $from = selection.$from,
        $to = selection.$to;
      var range = $from.blockRange($to);
      if (range) {
        return transformToTaskList(tr, range, nodes.taskList, undefined, nodes);
      }
    }
    return tr;
  };
};